export default {
  uploads: 'https://uploads.documents.cimpress.io',
};
